import { Component, inject, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { SiblingSignalService } from '../../services/submenudatasharing.service';

@Component({
  selector: 'app-sub-menu-tabs',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sub-menu-tabs.component.html',
})
export class SubMenuTabsComponent {

  private siblingBus = inject(SiblingSignalService);

  // this is a signal coming from the service
  subMenuItems = this.siblingBus.data;

  constructor( private router: Router) {
    effect(() => {
      console.log('Effect in SubMenuTabs – current submenu:', this.subMenuItems());
     
    });
  }

  onSubMenuClick(item: any) {
    console.log(item, 'item');
    this.router.navigate([item.url], {
      queryParamsHandling: 'merge'
    });
  }

  checkPermission(privileges: any[]): boolean {
    return privileges.some((privilege: any) => privilege.status === true);
  }
}
